import AuthMixin from '@/mixins/Auth';
import { mapGetters } from 'vuex';
import DashboardMenu from '@/components/Menus/DashboardMenu/DashboardMenu.vue';
import DashboardBtn from '@/components/Menus/DashboardMenu/DashboardBtn.vue';
import TableRequests from '@/components/Rail/TableRequests/TableRequests.vue';

export default {
    name: 'DashboardAdmin',

    mixins: [
        AuthMixin,
    ],

    components: {
        TableRequests,
        DashboardMenu,
        DashboardBtn,
    },

    computed: {
        ...mapGetters({
            userDisplayName: 'auth/userDisplayName',
        }),
    },

    async created() {
        await this.allowOnlyRoles(['rail_admin', 'rail_manager', 'tracker_admin', 'tracker_manager']);
    },
}